/**
 * @since 2016-08-07 12:59
 * @author vivaxy
 */

export const DEVELOPMENT = 'development';
export const LOCAL = 'local';
export const BETA = 'beta';
export const PPE = 'ppe';
export const PRODUCTION = 'production';
export const Staging = 'staging';



// WEBPACK FOOTER //
// ./src/config/environments.js